module.exports = __webpack_public_path__ + "static/media/To-Do-app.9b86939c.png";